/// <reference path="references.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var CastrolProofOfPurchase = /** @class */ (function () {
    //Methods
    function CastrolProofOfPurchase(promotionPromo, usePromotionRetailersList) {
        var thisObj = this;

        //Initialize variables
        this.stores = [];
        this.storesAlternative = [];
        this.storesLoaded = false;
        this.receiptType = "";

        /*let r = document.getElementById("StoreType-Container").querySelector("input:checked");
        if (r == null) { this.receiptType = ""; }
        else { this.receiptType = r.value; }*/

        //Link all HTML elements
        this.store_zip = document.getElementById("CastrolProofOfPurchase_StoreZip").getElementsByTagName("input")[0];
        this.store_seq = document.getElementById("CastrolProofOfPurchase_StoreLocation").getElementsByTagName("select")[0];
        this.store_seq_previous = document.getElementById("CastrolProofOfPurchase_PreviousStoreLocation");
        this.store_not_found = document.getElementById("CastrolProofOfPurchase_StoreNotFound").getElementsByTagName("input")[0];
        this.containerStore = document.getElementById("CastrolProofOfPurchase_Container-Store");
        this.containerNewStore = document.getElementById("CastrolProofOfPurchase_Container-NewStore");
        this.store_name_other = document.getElementById("CastrolProofOfPurchase_StoreLocationOther").getElementsByTagName("input")[0];
        this.store_type = document.getElementById("StoreType-Container").getElementsByTagName("input");

        ////Refresh the new installer display
        this.UpdateNewStore();
        //this.SleepTest();

        //Set all input events
        this.store_zip.onkeyup = function () {
            thisObj.UpdateStoresSelect();
        };
        this.store_not_found.onchange = function () {
            thisObj.UpdateNewStore();
        };
        for (store_type_i in this.store_type) {
            this.store_type[store_type_i].onchange = function () {
                this.receiptType = thisObj.GetReceiptType();
                thisObj.UpdateNewStore();
                thisObj.UpdateStoresSelect();
            };
        }


        //Get all of the authorized installer JSON data
        let dataDIFM = {
            promotionPromo: promotionPromo,
            usePromotionRetailersList: usePromotionRetailersList
        };
        $.ajax({
            url: GLOBALROOTURL + "/AjaxRequest/GetCastrolRetailerLocationsJson",
            type: "GET",
            data: dataDIFM,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (responseJSON) {
                //Returns two lists: 1) the DIFM location list, and 2) the DIY location list
                //console.log(responseJSON[0]);
                //console.log(responseJSON[1]);
                //Loop through the first list and add it to the stores list
                for (var _i = 0, responseJSON_1 = responseJSON[0]; _i < responseJSON_1.length; _i++) {
                    var ShopListJSON = responseJSON_1[_i];
                    var newShopListModel = new ShopListModel(ShopListJSON);
                    //console.log(ShopListJSON);
                    //console.log(newShopListModel);
                    thisObj.stores.push(newShopListModel);
                }
                //console.log(thisObj.stores);

                //Loop through the first list and add it to the stores list
                for (var _j = 0, responseJSON_2 = responseJSON[1]; _j < responseJSON_2.length; _j++) {
                    var ShopAlternativeListJSON = responseJSON_2[_j];
                    var newShopAlternativeListModel = new ShopListModel(ShopAlternativeListJSON);
                    //console.log(ShopAlternativeListJSON);
                    //console.log(newShopAlternativeListModel);
                    thisObj.storesAlternative.push(newShopAlternativeListModel);
                }
                //console.log(thisObj.storesAlternative);

                //Sort the list case-insentitive alphabetically by ShopName
                thisObj.stores.sort(function (a, b) {
                    return a.ShopName.localeCompare(b.ShopName, undefined, { sensitivity: "base" });
                });
                thisObj.storesAlternative.sort(function (a, b) {
                    return a.ShopName.localeCompare(b.ShopName, undefined, { sensitivity: "base" });
                });
            },
            error: function (exception) { console.log('Exception:' + exception); }
        }).then(function () {
            //Flag as true to allow updates using the data
            thisObj.storesLoaded = true;
            //Do the initial select update
            thisObj.UpdateNewStore();
            thisObj.UpdateStoresSelect(true);
        });
    }

    CastrolProofOfPurchase.prototype.GetReceiptType = function () {
        let selected = document.getElementById("StoreType-Container").querySelector("input:checked");
        if (selected == null) { return ""; }
        else { return selected.value; }
    };

    CastrolProofOfPurchase.prototype.UpdateNewStore = function () {
        if (this.store_not_found.checked) {
            this.containerStore.style.display = 'none';
            this.containerNewStore.style.display = '';
            this.store_name_other.required = true;
            this.store_seq.value = '';
        }
        else {
            this.containerStore.style.display = '';
            this.containerNewStore.style.display = 'none';
            this.store_name_other.required = false;
            this.store_name_other.value = '';
        }

        if (this.GetReceiptType() == "DIFM") {
            document.getElementById("CastrolProofOfPurchase_StoreZip").style.display = '';
        }
        else if (this.GetReceiptType() == "DIY") {
            document.getElementById("CastrolProofOfPurchase_StoreZip").style.display = 'none';
        }
    };

    CastrolProofOfPurchase.prototype.UpdateStoresSelect = function (setToPreviousSeq) {
        if (setToPreviousSeq === void 0) { setToPreviousSeq = false; }

        //Clear all entries first
        for (var i = this.store_seq.options.length - 1; i >= 0; i--) {
            this.store_seq.remove(i);
        }

        if (!this.storesLoaded) { //Default to Loading... if JSON is not yet loaded
            var newOption = document.createElement('option');
            newOption.text = 'Loading...';
            newOption.value = '';
            this.store_seq.appendChild(newOption);
        }
        else { //Only proceed if the the JSON data was loaded
            //Don't allow more than 5 characters to be entered
            if (this.store_zip.value.length > 5) {
                this.store_zip.value = this.store_zip.value.substring(0, 5);
            }

            //Prefix with zeroes to match SQL data in cases where it's an east-coast 1-4 character zip
            var formattedZip = '00000' + this.store_zip.value;
            formattedZip = formattedZip.trim();
            formattedZip = formattedZip.slice(formattedZip.length - 5, formattedZip.length);

            //Update the select options based on the zip code
            if (this.GetReceiptType() == "DIFM") {
                for (var _i = 0, _a = this.stores; _i < _a.length; _i++) {
                    var storeList = _a[_i];
                    if (storeList.ShopZip === formattedZip) {
                        this.store_seq.appendChild(storeList.GetAsHTMLOption());
                    }
                }
            }
            else if (this.GetReceiptType() == "DIY") {
                var placeholderOuput = document.createElement('option');
                placeholderOuput.text = '';
                placeholderOuput.value = '';
                this.store_seq.appendChild(placeholderOuput);
                for (var _i = 0, _a = this.storesAlternative; _i < _a.length; _i++) {
                    var storeList = _a[_i];
                    this.store_seq.appendChild(storeList.GetNameAsHTMLOption());
                }
            }

            //Update the display if no authorized installers were found
            if (this.store_seq.length === 0) {
                if (formattedZip === '00000') {
                    var newOption = document.createElement('option');
                    newOption.text = "Enter your location's zip above to search.";
                    newOption.value = '';
                    this.store_seq.appendChild(newOption);
                }
                else {
                    var newOption = document.createElement('option');
                    newOption.text = 'No location found for that zipcode ' + formattedZip;
                    newOption.value = '';
                    this.store_seq.appendChild(newOption);
                }
            }
            if (this.store_seq.length === 1) {
                if (formattedZip === '77777') {
                    for (var i = this.store_seq.options.length - 1; i >= 0; i--) {
                        this.store_seq.remove(i);
                    }
                    var newOption = document.createElement('option');
                    newOption.text = 'No location found for that zipcode ' + formattedZip;
                    newOption.value = '';
                    this.store_seq.appendChild(newOption);
                }
            }

            if (setToPreviousSeq) {
                if (this.store_seq_previous.value) {
                    this.store_seq.value = this.store_seq_previous.value;
                }
            }
        }
    };

    CastrolProofOfPurchase.prototype.SleepTest = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Sleep test 1');
                        return [4 /*yield*/, Apfco.Sleep(2000)];
                    case 1:
                        _a.sent();
                        console.log('Sleep test 2');
                        return [4 /*yield*/, Apfco.Sleep(2000)];
                    case 2:
                        _a.sent();
                        console.log('Sleep test 3');
                        return [2 /*return*/];
                }
            });
        });
    };

    return CastrolProofOfPurchase;
}());

var ShopListModel = /** @class */ (function () {
    function ShopListModel(ShopListJSON) {
        this.seq = ShopListJSON.key;
        this.ShopName = ShopListJSON.name;
        this.ShopAddress = ShopListJSON.address;
        this.ShopCity = ShopListJSON.city;
        this.ShopState = ShopListJSON.state;
        this.ShopZip = ShopListJSON.zip;
    }

    ShopListModel.prototype.GetAddressAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.ShopAddress;
        output.value = this.seq.toString();
        return output;
    };

    ShopListModel.prototype.GetCityAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.ShopCity;
        output.value = this.seq.toString();
        return output;
    };

    ShopListModel.prototype.GetStateAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.ShopState;
        output.value = this.seq.toString();
        return output;
    };

    ShopListModel.prototype.GetNameAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.ShopName;
        output.value = this.seq.toString();
        return output;
    };

    ShopListModel.prototype.GetAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.ShopName + ', ' + this.ShopAddress + ', ' + this.ShopCity + ', ' + this.ShopState;
        output.value = this.seq.toString();
        return output;
    };

    return ShopListModel;
}());
